const SeoSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: 'Tiny Wings Preschool',
    url: 'https://www.tinywingslearning.com/',
    logo: 'https://www.tinywingslearning.com/butterfly.png',
    image: 'https://images.pexels.com/photos/8613261/pexels-photo-8613261.jpeg?auto=compress&cs=tinysrgb&w=800',
    telephone: '+91 8624051851',
    email: 'info@tinywingslearning.com',
    description: 'Tiny Wings Preschool in Chhatrapati Sambhaji Nagar offers Playgroup, Nursery, Junior KG and Senior KG with activity-based learning, phonics and a caring environment.',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Plot No. 27, Honey Bunny Building, Near Datta Mandir, Mayur Park, Jalgaon Road, Chhatrapati Sambhaji Nagar - 431003',
      addressLocality: 'Chhatrapati Sambhaji Nagar',
      addressRegion: 'Maharashtra',
      postalCode: '431003',
      addressCountry: 'IN'
    },
    sameAs: [
      'https://www.facebook.com/profile.php?id=61586248660435',
      'https://www.instagram.com/tinywingslearning/',
      'https://x.com/TinyWingsLearn',
      'https://www.linkedin.com/in/tiny-wings-0807063a8/',
      'https://www.youtube.com/channel/UCXnyKr_aodF5V7mgx-mWMCg'
    ],
    openingHours: ['Mo-Sa 09:00-18:00'],
    areaServed: 'Chhatrapati Sambhaji Nagar, Maharashtra, India'
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Tiny Wings Preschool',
    url: 'https://www.tinywingslearning.com/',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.tinywingslearning.com/?s={search_term_string}',
      'query-input': 'required name=search_term_string'
    }
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What classes are available at Tiny Wings Preschool?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Tiny Wings Preschool offers Playgroup, Nursery, Junior KG and Senior KG.'
        }
      },
      {
        '@type': 'Question',
        name: 'Where is Tiny Wings Preschool located?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Tiny Wings Preschool is located near Datta Mandir and Mayur Park in Chhatrapati Sambhaji Nagar, Maharashtra.'
        }
      },
      {
        '@type': 'Question',
        name: 'What learning approach does Tiny Wings Preschool follow?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Tiny Wings Preschool focuses on activity-based learning, phonics, age-appropriate activities, early language development, creativity and school readiness.'
        }
      },
      {
        '@type': 'Question',
        name: 'How can parents enquire about admission?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Parents can contact Tiny Wings Preschool through the contact details provided on the website and enquire about available admissions.'
        }
      },
      {
        '@type': 'Question',
        name: 'Does Tiny Wings Preschool provide Playgroup and Nursery?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. Playgroup and Nursery are among the programs offered by Tiny Wings Preschool.'
        }
      }
    ]
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
};

export default SeoSchema;
